import { Component, OnInit, Input, input, inject } from '@angular/core';
import { of } from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PlayerListViewModel } from '../../../shared/models/player.model';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SelectRankingListDialogComponent } from '../../../shared/components/select-ranking-list-dialog/select-ranking-list-dialog.component';
import { PlayerListService } from '../../../shared/services/player-list.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'app-team-roster-player',
  imports: [CommonModule, MaterialModule, RouterModule, MatDialogModule],
    templateUrl: './team-roster-player.component.html',
    styleUrls: ['./team-roster-player.component.css']
})
export class TeamRosterPlayerComponent implements OnInit {

  @Input() Player: PlayerListViewModel;
  @Input() GameId: string;

  private dialog = inject(MatDialog);
  private playerListSrv = inject(PlayerListService);
  private snackBar = inject(MatSnackBar);


  constructor(public _router: Router) { }

  ngOnInit() {
    // console.log("sadkjflaskdjlkj");
    
  }

  navigate(event:any, PlayerId: string){
    //console.log(PlayerId);
    this._router.navigate(['/player/details', PlayerId]);
    event.stopPropagation();
  }

  addPushed(event:any, PlayerId: string, GameId: string){
    //console.log(PlayerId);
    //console.log(GameId);
    event.stopPropagation();
    this._router.navigate(['/scouting/report/new', PlayerId, GameId])
    event.stopPropagation();
  }

  openSelectRankingListDialog(): void {
    const dialogRef = this.dialog.open(SelectRankingListDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.playerListSrv.addPlayerInList(result, this.Player.LifelineScoutingId).subscribe({
          next: (res) => {
            // console.log('Player added to list successfully');
            const dialogRef = this.snackBar.open('Player added', 'GO TO LIST', {
              duration: 3000
            });

            dialogRef.onAction().subscribe(() => {
              this._router.navigate(['lists/details/' + result]);
            });


          }
        });
        //this.getData();
        // console.log('The dialog was closed with result:', result);
      }
    });
  }

}
